import type { TFetchFlagApiVersion } from '@crehana/feature-flags/store';

export const FEATURE_FLAG_ENABLE_PASSWORD_STRENGTH: [
  string,
  TFetchFlagApiVersion,
] = ['ENABLE_PASSWORD_STRENGTH', 'V5'];
